/**
 * This function ensures that the input is always an array.
 * @param value
 * @returns
 */
export function guardArray<T>(
	value: T | T[] | Readonly<T> | Readonly<T[]> | undefined | null,
): T[] {
	if (value == null) return [];
	if (Array.isArray(value)) return value;
	return [value as T];
}
